import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import him from "../../utils/images/vico.jpg";
import her from "../../utils/images/her2.jpg";
import { HeartFilled } from "@ant-design/icons";
const CoupleDetailWrapper = styled.div`
  background: #f2f2f2;
  .img-wraper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;
    justify-content: center;
    padding: 30px 15%;
    @media (max-width: 768px) {
      display: grid;
      grid-template-columns: 1fr;
      padding: 20px 5%;
    }
  }
  img {
    width: 100%;
    height: 458px;
    object-fit: cover;
  }

  .view {
    position: relative;
    overflow: hidden;
    /* cursor: pointer; */
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
    background-attachment: fixed;
    display: grid;
    place-items: center;
  }

  .overlay .mask {
    opacity: 0;
    transition: all 0.4s ease-in;
  }

  .overlay .mask:hover {
    opacity: 1;
    text-align: center;
    display: flex;
    align-items: center;
    transition: 0.5s;
    overflow: hidden;
    justify-content: center;
    background: rgba(0, 0, 0, 0.8);
    transition: opacity 0.3s;
  }
  .btn {
    display: inline-block;
    margin: 0 auto;
    background-color: transparent;
    font-family: "Oswald", sans-serif;
    border: solid 1px #fafafa;
    padding: 10px 50px;
    font-size: 16px;
    color: #fff;
    text-transform: uppercase;
  }

  .btn:hover {
    background-color: #f0394d;
    border-color: #f0394d;
    color: #fff;
    text-decoration: none;
  }
  .photo-item {
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  border-photo-caption {
    opacity: 1;
  }
  .wh95 {
    width: 95%;
    height: 95%;
    border: 1px solid #fff;
    display: grid;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 8%;
  }
  .banner-text.light {
    color: #fff;
    border-top: medium double #fff;
    border-bottom: medium double #fff;
    letter-spacing: 3px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 17px;
    display: grid;
    @media (max-width: 420px) {
      justify-self: center;
      font-size: 110%;
      letter-spacing: 2px;
      text-transform: capitalize;
    }
  }
  .banner-text.medium {
    padding: 8px 50px;
    @media (max-width: 420px) {
      padding: 8px 40px;
    }
  }
  .heart-divider {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
  }
  .text {
    padding-top: 20px;
    font-size: 16px;
    font-family: muli;
    @media (max-width: 768px) {
      font-size: 120%;
    }
  }
  .grow {
    transition: all 0.2s ease-in-out;
  }
  .grow:hover {
    transform: scale(1.1);
  }
  #desc {
    font-family: "Pacifico", cursive;
    color: #123333;
  }
`;

export default function CoupleDetail() {
  return (
    <>
      <CoupleDetailWrapper>
        <div className="img-wraper">
          <div>
            <div className="overlay view">
              <img src={him} alt="groom pix" />
              <div className="photo-item  border-photo-caption wh95 ">
                <div>
                  <div className="heart-divider">
                    <HeartFilled
                      className="pink-dot"
                      style={{ fontSize: 18, color: "red" }}
                    />
                    <HeartFilled
                      style={{ fontSize: 19, marginLeft: -5, color: "#fafaf6" }}
                    />
                  </div>
                  <span className="banner-text light medium">
                    *** the groom ***
                  </span>
                </div>
              </div>
              <div className="mask">
                <Link to="/about-him">
                  <span className="btn">about him</span>
                </Link>
              </div>
            </div>
            <div className="text">
              <b> I'm David Victor Ugbede</b> sit amet consectetur adipisicing
              elit. Tempora exercitationem, aliquid saepe, fuga reprehenderit
              commodi quidem fugit esse nisi ipsam enim eveniet minima dolorum
              nulla delectus adipisci ut? Quaerat, quas!
            </div>
          </div>
          <div>
            <div className="overlay view">
              <img src={her} alt="bride pix" />

              <div className="photo-item  border-photo-caption wh95">
                <div>
                  <div className="heart-divider">
                    <HeartFilled
                      className="pink-dot"
                      style={{ fontSize: 18, color: "red" }}
                    />
                    <HeartFilled
                      style={{ fontSize: 19, marginLeft: -5, color: "#fafaf6" }}
                    />
                  </div>
                  <span className="banner-text light medium">
                    *** the bride ***
                  </span>
                </div>
              </div>
              <div className="mask ">
                <Link to="/about-her">
                  <span className="btn">about her</span>
                </Link>
              </div>
            </div>
            <div className="text">
              <b>I'm David Ufedo</b> sit amet consectetur adipisicing elit.
              Tempora exercitationem, aliquid saepe, fuga reprehenderit commodi
              quidem fugit esse nisi ipsam enim eveniet minima dolorum nulla
              delectus adipisci ut? Quaerat, quas!
            </div>
          </div>
        </div>
      </CoupleDetailWrapper>
    </>
  );
}
